import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from "react-i18next";
import {
  c2DialogPaperSx,
  c2DialogTitleSx,
  c2IconBoxSx,
  c2DialogBodySx,
  c2PrimaryBtnSx,
} from './conecta2ModalStyles';

const ES_FALLBACKS = {
  day_invalid: 'Solo puedes retirar los días 15 y 30 de cada mes.',
  wallet_bal_low: 'Saldo de billetera insuficiente.',
  wallet_bal_low_b: 'Saldo insuficiente. Necesitas más de COP$ 100.000 para retirar.',
  wallet_balance_low: 'Saldo de billetera insuficiente.',
  valid_amount: 'Ingresa un monto válido.',
  profile_incomplete: 'Completa tu perfil (nombre, correo y teléfono) para continuar.',
  provider_not_found: 'No se encontraron proveedores de pago.',
  no_details_error: 'Completa todos los datos correctamente.',
  demo_mode: 'Modo demo: acción no permitida.',
  choose_image_first: 'Primero elige una imagen.',
  profile_updated: 'Perfil actualizado correctamente.',
  proper_email: 'Ingresa un correo electrónico válido.',
  login_error: 'Error al iniciar sesión. Revisa tus datos.',
  otp_validate_error: 'Código OTP inválido.',
  user_exists: 'El usuario ya existe.',
  update_any: 'No puedes cambiar correo y teléfono al mismo tiempo.',
};

function resolveMessage(children, t) {
  if (typeof children !== 'string') return children;
  const keyLike = /^[a-z][a-z0-9_]*$/i.test(children);
  if (keyLike && (ES_FALLBACKS[children] || children.includes('_'))) {
    return t(children, { defaultValue: ES_FALLBACKS[children] || children });
  }
  return children;
}

export default function AlertDialog(props) {
  const { t } = useTranslation();
  const { open, onClose, children } = props;
  const message = resolveMessage(children, t);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{ sx: c2DialogPaperSx }}
    >
      <DialogTitle id="alert-dialog-title" sx={c2DialogTitleSx}>
        <Box sx={c2IconBoxSx}>
          <InfoOutlinedIcon sx={{ color: '#6411ED', fontSize: 22 }} />
        </Box>
        {t('alert', { defaultValue: 'Aviso' })}
      </DialogTitle>
      <DialogContent sx={{ px: 2.5, pb: 1 }}>
        <DialogContentText id="alert-dialog-description" sx={{ ...c2DialogBodySx, pt: 0.5 }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 2.5, pt: 1 }}>
        <Button onClick={onClose} variant="contained" sx={c2PrimaryBtnSx}>
          {t('close', { defaultValue: 'Cerrar' }).toString().toUpperCase()}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
